import { Controller } from '@hotwired/stimulus'
import { pauseYoutubeIframes } from '../utils/youtube'

export default class extends Controller {
  static targets = ['item', 'filter']

  filter(event) {
    event.preventDefault()

    const type = event.currentTarget.dataset.galleryFilterType

    this.filterTargets.forEach((el) => {
      el.classList.toggle('active', el.dataset.galleryFilterType === type)
    })

    this.itemTargets.forEach((el) => {
      const itemType = el.dataset.galleryFilterItemType
      el.classList.toggle('d-none', this.#isHidden(itemType, type))
    })

    pauseYoutubeIframes(this.element)
  }

  #isHidden(itemType, activeType) {
    return activeType !== 'all' && itemType !== activeType
  }
}
